export default class ResetGame {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.game.resetGame();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.walletProtocol) {
            default:
                event["resetGame"] = this._default;
        }

        return event;
    }
}
